import React from "react"
import DollarIcon from "../icons/IconLib/DollarIcon"
import EuroIcon from "../icons/IconLib/EuroIcon"
import ShekelIcon from "../icons/IconLib/ShekelIcon"

type AvailableCurrency = 'EUR' | 'USD' | 'NIS';
type CurrencyIconType = React.JSX.Element; // Assuming your icons are JSX elements
// Define the type for the object with an index signature
type CurrencyCodesType = {
  [key: string]: CurrencyIconType;
};

const currencyCodes: CurrencyCodesType  = {
  'EUR': <EuroIcon />,
  'USD': <DollarIcon />,
  'NIS': <ShekelIcon />,
}
export const currencyIconByCode = (code: string): CurrencyIconType  => {
  return currencyCodes[code] || <ShekelIcon />
}